import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {getScenarioById, getChallengeScenariosLength} from "../../../scenes/editor/challenge-edit.utils";

import {MAX_CHALLENGE_LENGTH, MAX_MAIN_SCENARIO_LENGTH} from "../../../settings";
import {Scenario} from "../../../types";
import {TFunction} from "i18next";

import cn from "classnames";
import classes from "./ChallengeLength.module.css";

export type ChallengeScenariosLengthProps = React.ComponentProps<"div"> & {
  scenarios: Scenario[];
  currentScenarioId: Scenario["id"];
};
export default function ChallengeScenariosLength({
  scenarios,
  currentScenarioId,
  className,
  ...props
}: ChallengeScenariosLengthProps) {
  const {t} = useTranslation();

  const currentScenario = useMemo(() => getScenarioById(scenarios, currentScenarioId), [scenarios, currentScenarioId]);

  const challengeLength = useMemo(() => getChallengeScenariosLength(scenarios), [scenarios]);

  const currentScenarioLength = currentScenario.actions.length;

  const challengeHaveSecondaryScenario = scenarios.length > 1;

  const isChallengeTooLong = challengeLength > MAX_CHALLENGE_LENGTH;

  const isMainScenarioTooLong = currentScenario.isMain && currentScenarioLength > MAX_MAIN_SCENARIO_LENGTH;

  if (isChallengeTooLong || isMainScenarioTooLong) {
    if (challengeHaveSecondaryScenario) {
      return (
        <div className={cn(classes.root, className)} {...props}>
          <span>
            {t("components.ChallengeScenariosLength.challengeLength", {
              length: getActionPlural(t, challengeLength),
              max: challengeHaveSecondaryScenario ? MAX_CHALLENGE_LENGTH : MAX_MAIN_SCENARIO_LENGTH,
            })}
          </span>
          {currentScenario.isMain && isMainScenarioTooLong ? (
            <span>
              {t("components.ChallengeScenariosLength.mainScenarioLength", {
                length: getActionPlural(t, currentScenarioLength),
                max: MAX_MAIN_SCENARIO_LENGTH,
              })}
            </span>
          ) : (
            <span>
              {t("components.ChallengeScenariosLength.scenarioLength", {
                length: getActionPlural(t, currentScenarioLength),
              })}
            </span>
          )}
        </div>
      );
    } else {
      return (
        <div className={cn(classes.root, className)} {...props}>
          <span>
            {t("components.ChallengeScenariosLength.challengeLength", {
              length: getActionPlural(t, challengeLength),
              max: MAX_MAIN_SCENARIO_LENGTH,
            })}
          </span>
        </div>
      );
    }
  }

  return null;
}

function getActionPlural(t: TFunction, count: number) {
  return t("types.plurals.action", {count});
}
